// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3lGAW","productName":"Table_productName__CXMC3"};